<template>
    <v-menu offset-y :disabled="readonly">
        <template #activator="{ on }">
            <button class="btn-filter-left" :class="{'icon-arrow-down': !readonly}" v-on="on"><span v-if="value.item">{{ value.item.label }}</span></button>
        </template>
        <div class="filter-dropdown" :data-level="activeLevel">
            <ul>
                <filter-item-menu-item v-for="field in getSearchOptions"
                                       :option="field"
                                       :key="field.handle"
                                       :path="field.handle"
                                       v-model="getValue"
                                       @change-level="changeLevel($event)"></filter-item-menu-item>
            </ul>
        </div>
    </v-menu>
</template>

<script>
  import FilterItemMenuItem from '@/components/filter/FilterItemMenuItem'

  export default {
    components: { FilterItemMenuItem },
    props: {
      value: {
        type: Object
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        activeLevel: 0
      }
    },
    methods: {
      changeLevel (event) {
        this.activeLevel = event
      }
    },
    computed: {
      getSearchOptions () {
        return this.$store.getters['search/getSearchOptions']
      },
      getValue: {
        get () {
          return this.value
        },
        set (newVal) {
          this.$emit('input', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>
